<div class="showcase">
  <div class="showcase-visual" role="img" [attr.aria-label]="'SIGNUP.SHOWCASE.TAGLINE' | translate">
    <img class="showcase-dashboard" src="../../assets/images/sign-up/dashboard.png" alt="" />

    <img class="showcase-bubble showcase-bubble-1" src="../../assets/images/sign-up/avatar-bubble-1.png" alt="" />
    <img class="showcase-bubble showcase-bubble-2" src="../../assets/images/sign-up/avatar-bubble-2.png" alt="" />
    <img class="showcase-bubble showcase-bubble-3" src="../../assets/images/sign-up/avatar-bubble-3.png" alt="" />

    <div class="ai-card ai-card-receptionist">
      <img class="ai-card-avatar" src="../../assets/images/sign-up/avatar-receptionist.png" alt="" />
      <div class="ai-card-bubble">
        <div class="ai-card-title">{{ 'SIGNUP.SHOWCASE.RECEPTIONIST_TITLE' | translate }}</div>
        <p class="ai-card-body">{{ 'SIGNUP.SHOWCASE.RECEPTIONIST_BODY' | translate }}</p>
        <div class="ai-card-meta">
          <img class="ai-card-check" src="../../assets/images/sign-up/check-icon.svg" alt="" />
          <span>{{ 'SIGNUP.SHOWCASE.RECEPTIONIST_META' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="ai-card ai-card-reputation">
      <div class="ai-card-bubble">
        <div class="ai-card-title-row">
          <div class="ai-card-title">{{ 'SIGNUP.SHOWCASE.REPUTATION_TITLE' | translate }}</div>
          <div class="ai-card-stars">★★★★★</div>
        </div>
        <p class="ai-card-body">{{ 'SIGNUP.SHOWCASE.REPUTATION_BODY' | translate }}</p>
        <div class="ai-card-meta">
          <span>{{ 'SIGNUP.SHOWCASE.REPUTATION_META' | translate }}</span>
        </div>
      </div>
      <img class="ai-card-avatar" src="../../assets/images/sign-up/avatar-reputation.png" alt="" />
    </div>

    <div class="ai-card ai-card-social">
      <img class="ai-card-avatar" src="../../assets/images/sign-up/avatar-social.png" alt="" />
      <div class="ai-card-bubble">
        <div class="ai-card-title">{{ 'SIGNUP.SHOWCASE.SOCIAL_TITLE' | translate }}</div>
        <p class="ai-card-body">{{ 'SIGNUP.SHOWCASE.SOCIAL_BODY' | translate }}</p>
        <div class="ai-card-progress"></div>
      </div>
    </div>
  </div>

  <div class="g2-module">
    <div class="g2-rating">
      <div class="g2-rating-label">{{ 'SIGNUP.SHOWCASE.G2_LABEL' | translate }}</div>
      <div class="g2-rating-row">
        <img class="g2-logo" src="../../assets/images/sign-up/g2-logo.svg" alt="G2" />
        <img class="g2-stars" src="../../assets/images/sign-up/g2-stars.svg" alt="" />
        <span class="g2-score">{{ 'SIGNUP.SHOWCASE.G2_SCORE' | translate }}</span>
      </div>
    </div>
    <div class="g2-medals">
      <img src="../../assets/images/sign-up/medal-regional-leader.png" alt="G2 Regional Leader badge" />
      <img src="../../assets/images/sign-up/medal-leader.png" alt="G2 Leader badge" />
      <img src="../../assets/images/sign-up/medal-high-performer.png" alt="G2 High Performer badge" />
      <img src="../../assets/images/sign-up/medal-users-love-us.png" alt="G2 Users Love Us badge" />
    </div>
  </div>
</div>
